import { observable, action, computed } from "mobx"
import _ from "lodash"

class UserStore {
  @observable currentUser
}

export default new UserStore()
